import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="py-24 md:py-32 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(circle at center, rgba(59, 130, 246, 0.06) 0%, transparent 60%)" }} />

      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2
            data-testid="final-cta-heading"
            className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight mb-6"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            Stop losing leads. Let's build your AI.
          </h2>
          <p className="text-zinc-400 text-base md:text-lg max-w-xl mx-auto mb-10 leading-relaxed">
            Book a free 15 minute strategy call. We'll show you exactly what we'd build for your business and what it would change.
          </p>
          <Button
            data-testid="final-cta-button"
            onClick={() => window.location.href = "/apply.html"}
            className="bg-blue-600 hover:bg-blue-500 text-white rounded-full px-10 py-6 text-base font-bold transition-all duration-200 hover:scale-105 shadow-[0_0_40px_rgba(59,130,246,0.4)] inline-flex items-center gap-2"
          >
            Book My Free Strategy Call <ArrowRight size={18} />
          </Button>
          <p className="text-zinc-600 text-xs mt-5">
            No commitment. No pitch deck. Just a straight conversation about your business.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
